import { useCallback, useEffect, useState } from 'react';
import { fetchPasswords } from '../services/passwordsApi';

const usePasswords = () => {
  const [passwords, setPasswords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadPasswords = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchPasswords();
      setPasswords(data);
    } catch (err) {
      setError(err.message || 'Failed to load passwords');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPasswords();
  }, [loadPasswords]);

  const refetch = useCallback(async () => {
    try {
      setError(null);
      const data = await fetchPasswords();
      setPasswords(data);
    } catch (err) {
      setError(err.message || 'Failed to load passwords');
    }
  }, []);

  return { passwords, loading, error, refetch };
};

export default usePasswords;
